import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useSuperAdminLoginMutation } from "../../store/auth/auth.api";
import { getIsAuthenticated } from "../../store/auth/selectors";
import { USER_TYPES } from "../../store/auth/auth.slice";
import inmobius_IL_logo from "../../assets/images/inmobius_IL_logo.svg";
import login_Bg from "../../assets/images/login-bg.png";
import footer_Bg from "../../assets/images/footer-bg.png";
import hide_password_icon from "../../assets/images/hide_password_icon.png";
import show_password_icon from "../../assets/images/show_password_icon.png";

import "./Login.css";

const LoginPage = () => {
  const [loginError, setLoginError] = useState("");
  const [accountType, setAccountType] = useState("Infinity Admin");
  const [phone, setPhone] = useState("");
  const [isdCode, setIsdCode] = useState("+91");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [superAdminLogin, { isLoading, error }] = useSuperAdminLoginMutation();

  const isAuthenticated = useSelector(getIsAuthenticated);

  // Watch for authentication state changes after login attempt
  const [loginAttempted, setLoginAttempted] = useState(false);

  useEffect(() => {
    if (loginAttempted) {
      if (isAuthenticated) {
        navigate("/app");
      } else {
        setLoginError(
          "Access denied. Your role does not have permission to access this application."
        );
      }
      setLoginAttempted(false);
    }
  }, [isAuthenticated, loginAttempted, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError("");
    try {
      const loginType =
        accountType === "School Admin"
          ? USER_TYPES.SCHOOL
          : USER_TYPES.SUPERADMIN;
      const body = {
        phone,
        password,
        isd_code: isdCode,
        login_type: loginType,
      };
      await superAdminLogin({ body }).unwrap();
      setLoginAttempted(true);
    } catch (err) {
      console.error("Login failed:", err);
      setLoginError(
        "Login failed. Please check your credentials and try again."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login--bg">
        <img src={login_Bg} alt="login-bg" />
      </div>
      <div className="footer--bg">
        <img src={footer_Bg} alt="login-bg-two" />
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="left-panel">
            <div className="logo">
              <img src={inmobius_IL_logo} alt="Infinity Learn Logo" />
            </div>
            <h2>
              Welcome Back to
              <br />
              Infinity Learn
            </h2>
            <div className="yellow-line"></div>
          </div>

          <div className="right-panel">
            <h1>LOGIN</h1>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Account Type</label>
                <select
                  value={accountType}
                  onChange={(e) => setAccountType(e.target.value)}
                >
                  <option value="Infinity Admin">Infinity Admin</option>
                  <option value="School Admin">School Admin</option>
                </select>
              </div>

              <div className="form-group">
                <label>ISD Code</label>
                <select
                  value={isdCode}
                  onChange={(e) => setIsdCode(e.target.value)}
                >
                  <option value="+91">+91 India</option>
                  <option value="+971">+971 UAE</option>
                </select>
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Password</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <img
                    src={showPassword ? hide_password_icon : show_password_icon}
                    alt="toggle password visibility"
                    className="password-toggle-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "LOGIN"}
              </button>
              {(error || loginError) && (
                <p className="login-error-message">
                  {loginError || "Login failed. Please refresh and try again."}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
